import { FC } from 'react'
import { LogoProps } from './Logo.types'
import cx from 'classnames'
import styles from './Logo.module.scss'

export const Logo: FC<LogoProps> = (props) => {
	const { color = 'white', className } = props
	return (
		<svg
			className={cx(styles.logo, className)}
			viewBox="0 0 96 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.9093 11.8672C18.9093 13.232 17.8077 14.3378 16.4493 14.3378H9.5909C8.23267 14.3378 7.13106 13.232 7.13106 11.8672V8.54766C7.13106 7.18271 8.23267 6.07682 9.5909 6.07682H16.4493C17.8077 6.07682 18.9093 7.18271 18.9093 8.54766V11.8672ZM18.9093 31.4373C18.9093 32.8021 17.8077 33.9081 16.4493 33.9081H9.5909C8.23267 33.9081 7.13106 32.8021 7.13106 31.4373V26.851C7.13106 25.4862 8.23267 24.3802 9.5909 24.3802H16.4493C17.8077 24.3802 18.9093 25.4862 18.9093 26.851V31.4373ZM19.232 0H6.80691C3.0453 0.00170949 0 3.06247 0 6.84215V12.1391C0 14.9249 1.64562 17.2985 4.00709 18.37V19.3497C1.64562 20.4211 0 22.8091 0 25.5797V33.1577C0 36.9385 3.04716 40 6.81016 40H19.2285C22.9916 40 26.0389 36.9385 26.0389 33.1577V25.5797C26.0389 22.8091 24.3933 20.4211 22.0317 19.3497V18.37C24.3933 17.2985 26.0389 14.9097 26.0389 12.1391V6.84215C26.0389 3.06247 22.9935 0.00170949 19.232 0Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M59.2524 37.0895H69.0915V33.8615H62.5997V31.3731H67.8205V28.2127H62.5997V25.7242H69.0915V22.4963H59.2524V37.0895Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M79.266 10.3365H75.8524V4.48596H72.4388V19.0791H75.8524V13.5644H79.266V19.0791H82.6794V4.48596H79.266V10.3365Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M72.5049 37.0895H82.344V33.8615H75.8514V31.3731H81.0729V28.2127H75.8514V25.7242H82.344V22.4963H72.5049V37.0895Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M91.3149 28.8844H88.7717V25.589H91.3149C92.118 25.589 92.7205 25.8582 92.7205 27.1355C92.7205 28.3459 92.2518 28.8844 91.3149 28.8844ZM91.716 22.4952H85.4242V37.0885H88.7713V31.9106H91.716C93.3219 31.9106 95.998 30.9692 96 27.2067V27.1987C95.998 23.1677 93.389 22.4952 91.716 22.4952Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M64.0726 13.4978H66.0805C66.0805 15.6496 65.3447 16.1881 63.9389 16.1881C62.399 16.1881 61.8638 15.3136 61.8638 13.4978V9.12697C61.8638 7.91556 62.7342 7.17613 63.9389 7.17613C65.3447 7.17613 65.8798 8.05061 65.8798 9.12697H69.3606C69.3606 6.63842 67.6869 4.15002 63.9389 4.15002C60.1238 4.15002 58.4502 6.03326 58.4502 9.12697V13.4978C58.4502 15.9864 59.2534 19.2142 63.9389 19.2142C68.4237 19.2142 69.4277 16.4572 69.4277 13.6319V10.8075H64.0726V13.4978Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M40.1091 28.2802C38.5026 28.011 38.1011 27.2715 38.1011 26.8006C38.1011 25.8593 38.7707 25.3884 39.9082 25.3884C41.1802 25.3884 41.5147 26.1953 41.5147 26.6661H44.7273C44.7273 24.9848 43.5898 22.1604 39.9082 22.1604C35.8251 22.1604 34.7548 24.8507 34.7548 26.868C34.7548 29.2215 36.6282 30.7012 39.373 31.1046C40.3099 31.2389 41.6481 31.5082 41.6481 32.7187C41.6481 33.6606 41.113 34.2659 39.9082 34.2659C39.1051 34.2659 38.1011 34.1307 38.1011 32.3152H34.7548C34.7548 34.1307 35.2227 37.292 39.9082 37.292C44.5267 37.292 45.0625 33.9966 45.0625 32.6512C45.0625 29.8267 43.1881 28.8179 40.1091 28.2802Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M44.794 15.7849H38.3013V13.2963H43.5219V10.1359H38.3013V7.64754H44.794V4.41956H34.955V19.0128H44.794V15.7849Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M51.2862 22.4963H47.9399V37.0896H56.1727V33.7275H51.2862V22.4963Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M88.7704 19.08H92.2511V7.84884H95.3303V4.48596H85.6247V7.84884H88.7704V19.08Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M50.2839 15.9187H47.9416V19.08H56.0407V15.9187H53.6303V7.64712H55.9734V4.48596H47.8745V7.64712H50.2839V15.9187Z"
				fill={color}
			/>
		</svg>
	)
}
